import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { I18nModule } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { TooltipTextModule } from '../tooltip-text/tooltip-text.module';
import { ErpPromotionalTextComponent } from './erp-promotional-text/erp-promotional-text.component';
import { PromotionalTextComponent } from './promotional-text.component';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    SharedModule,
    I18nModule,
    TooltipTextModule,
    PromotionalTextComponent,
    ErpPromotionalTextComponent,
  ],
  exports: [PromotionalTextComponent, ErpPromotionalTextComponent, TooltipTextModule],
})
export class PromotionalTextModule {}
